import { useId } from 'react';
import { CopyButton } from './CopyButton';
import { SECTION_HEADING_CLASS } from './browserStyles';
import type { DetailRow } from './iteroBrowseFormat';

const MISSING_VALUE = 'Not recorded';

function DetailValue({ row }: { row: DetailRow }) {
    if (row.value === null) {
        return <span className="text-gray-400">{MISSING_VALUE}</span>;
    }
    return (
        <span className="inline-flex items-start gap-1 min-w-0 max-w-full">
            <span
                className={`min-w-0 break-words ${row.multiline ? 'whitespace-pre-line' : ''} ${row.copyable ? 'font-mono text-[12px] break-all' : ''}`}
            >
                {row.value}
            </span>
            {row.copyable && <CopyButton text={row.value} label={row.label} />}
        </span>
    );
}

interface DetailListProps {
    rows: readonly DetailRow[];
    title?: string;
}

export function DetailList({ rows, title }: DetailListProps) {
    const headingId = useId();
    return (
        <section aria-labelledby={title ? headingId : undefined} className="flex flex-col gap-1.5">
            {title && (
                <h4 id={headingId} className={SECTION_HEADING_CLASS}>
                    {title}
                </h4>
            )}
            <dl className="grid grid-cols-[132px_minmax(0,1fr)] gap-x-3 gap-y-1.5 text-[13px]">
                {rows.map((row) => (
                    <div key={row.label} className="contents">
                        <dt className="text-gray-500">{row.label}</dt>
                        <dd className="text-gray-800 min-w-0">
                            <DetailValue row={row} />
                        </dd>
                    </div>
                ))}
            </dl>
        </section>
    );
}
